import React, { memo } from 'react'
import PropTypes from 'prop-types'

export const ComplianceRequirements = memo(({ requirements = [] }) =>
  (requirements || []).length ? (
    <div className='row' data-test='compliance-requirements'>
      <p className='col-xs-12 text-secondary'>Compliance Requirements</p>
      <div className='row'>
        <div className='col-xs-12'>
          <ul>
            {requirements.map(label => (
              <li key={label} data-test='compliance-requirement'>
                {label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  ) : null
)

ComplianceRequirements.propTypes = {
  requirements: PropTypes.arrayOf(PropTypes.string),
}

ComplianceRequirements.defaultProps = {
  requirements: [],
}
